import { registerLocaleData } from '@angular/common';
import localeSl from '@angular/common/locales/sl';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import '@progress/kendo-angular-intl/locales/sl/all';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.name === 'production') {
    enableProdMode();
}

registerLocaleData(localeSl, 'sl');

if (environment.name === 'local') {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
} else {
    bootstrapApplication(AppComponent, appConfig);
}
